ScrollableView = require("../scrollable/view")

class ExpandableListView extends ScrollableView
  template: require("./template")

  events:
    "iostap .item-button": "toggleItem"
    "iostap .btn-done":    "submit"

  serialize: ->
    data = super
    data.list = _.filter data.list, (el) -> el.title and el.content
    data.hasPrompt = true
    data

  beforeShow: ->
    @setEl @findAll(".item"), "items"
    @setEl @findOne(".content-scroll-inner"), "container"
    @setEl @findOne(".accordion"), "accordion"

    @$(".item-button .md-list").removeClass("md-list")

    @transformItems(false)

    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  show: ->
    @touchedItems = []
    @setState("prompt")
    @listenTo this, "resize", @onResize

  onResize: ->
    @beforeShow()

  onRefresh: ->

  toggleItem: (e, element) ->
    button       = e?.currentTarget or element
    currentItem  = button.parentNode
    transition   = e?

    @touchedItems = _.uniq @touchedItems.concat(currentItem)
    @setState("touched") if @touchedItems.length is @getEl("items").length

    for other in @getEl("items")
      @transition other, if transition then "all 300ms" else ""

      if @options.data.focus and other isnt currentItem
        other.classList.remove("active")

    currentItem.offsetHeight
    currentItem.classList.toggle "active"

    @transformItems(transition)

  transformItems: (transition) ->
    accordion = @getEl("accordion")

    return unless accordion? and @getEl("items").length

    window.clearTimeout @timeout

    yOffset = 0
    height  = 0

    for item, i in @getEl("items")
      button = item.firstChild
      height += button.offsetHeight

      @transform item, y: yOffset

      if item.classList.contains "active"
        height  += item.lastChild.offsetHeight
        yOffset += item.lastChild.offsetHeight

    if height > accordion.offsetHeight or not transition
      @transformContainer(height, transition)
    else
      @timeout = window.setTimeout =>
        @transformContainer(height, transition)
      , 300

  transformContainer: (height, transition) ->
    container = @getEl("container")
    accordion = @getEl("accordion")

    accordion.style.height = height + "px"

    diff = @el.offsetHeight - container.offsetHeight
    newY = Math.max diff / 2, 0

    @transform container,
      y: newY
      transition: if transition then "all 300ms" else ""

  refresh: (params) ->
    for item, i in params.data.list
      changed = i unless _.isEqual @options.data.list[i], item

    super

    @beforeShow()
    @show()

    if changed? and changed < @getEl("items").length
      @toggleItem null, @getEl("items")[changed].firstChild


module.exports = ExpandableListView
